import axiosInstance from 'service/api';

export default class IndependentPartFiltersService {
    static getIndependentPartFilterList() {
        const endPoint = `${window.config.genericGet}?collectionName=${window.config['collections']['masterLookup']}&search={}`;
        return axiosInstance.get(endPoint);
    }
}